import { render, staticRenderFns } from "./FieldAccidentPdfStatus.vue?vue&type=template&id=34dde411&"
import script from "./FieldAccidentPdfStatus.vue?vue&type=script&lang=js&"
export * from "./FieldAccidentPdfStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34dde411')) {
      api.createRecord('34dde411', component.options)
    } else {
      api.reload('34dde411', component.options)
    }
    module.hot.accept("./FieldAccidentPdfStatus.vue?vue&type=template&id=34dde411&", function () {
      api.rerender('34dde411', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldAccidentPdfStatus.vue"
export default component.exports